import { render } from "./ExpandableImage.vue?vue&type=template&id=7b8bccda"
import script from "./ExpandableImage.vue?vue&type=script&lang=js"
export * from "./ExpandableImage.vue?vue&type=script&lang=js"

import "./ExpandableImage.vue?vue&type=style&index=0&id=7b8bccda&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__